export default __webpack_public_path__ + "static/media/banner-01.1dfcb521.jpg";